module.exports = __webpack_public_path__ + "static/media/crazy-uber.tar.8ab25529.gz";